import React, { Component } from "react";

import "reactjs-popup/dist/index.css";
import "./Header.css";
import Consts from "../Constants/AppConsts.json";
import UniLogo from "../Assets/Images/usj.png";

export default class UniMap extends Component {
  onClickUniLogo = () => {
    window.open("http://sjp.ac.lk");
  };

  onPressDepartmentLocations = () => {
    if (this.props.clickLocations) this.props.clickLocations();
  };
  onPressFacHome = () => {
    window.open("http://fhss.sjp.ac.lk");
  };
  onPressExplore = () => {
    this.props.history.replace(`/`);
  };
  render() {
    const date = new Date();
    return (
      <div>
        <div className="glass">
          <img
            onClick={this.onClickUniLogo}
            src={UniLogo}
            alt="Logo"
            className="uniLogo"
          />
          <div>
            <header className="headerText">{this.props.headerText}</header>
            {this.props.subHeaderText ? (
              <header className="headerText">{this.props.subHeaderText}</header>
            ) : null}
            <header className="headerText">{Consts.Header_Fac_Text}</header>
            <header className="headerText">{Consts.Header_Uni_Text}</header>
          </div>
          <div className="linkDiv">
            <header onClick={this.onPressFacHome} className="LinkTexts">
              Faculty Home
            </header>
            {this.props.subHeaderText ? (
              <header
                onClick={this.onPressDepartmentLocations}
                className="LinkTexts"
              >
                Department Locations
              </header>
            ) : null}
            <header onClick={this.onPressExplore} className="LinkTexts">
              Change Virtual Tour
            </header>
          </div>
          <div>
            {this.props.subHeaderText ? (
              <i
                onClick={this.onPressDepartmentLocations}
                className="fa fa-list icon-color"
              >
                {" "}
              </i>
            ) : null}
            <i
              onClick={this.onPressExplore}
              className="fa fa-hand-pointer icon-color"
            >
              {" "}
            </i>
          </div>
        </div>
        <div className="glass-footer">
          <header className="crText">
            {Consts.Copyright_Text.replace("{{year}}", date.getFullYear())}
          </header>
        </div>
      </div>
    );
  }
}
